import React from 'react';

interface TrashIconProps {
  isRelative?: boolean;
  isRed?: boolean;
  className?: string;
}

export const TrashIcon: React.FC<TrashIconProps> = ({ isRelative, isRed, className }) => {
  return (
    <i
      className={`icon ${isRed ? 'icon-trash-red' : 'icon-trash'} ${isRelative ? 'relative' : ''} ${className || ''}`}
    />
  );
};

